import React from "react"
import { PropTypes } from "prop-types"

const Navigation = (props) => {
	const { goNext, goPrevious, currentStep, maxSteps, saveComponentState } = props;
	const btnStyle = {
		fontSize:'16px',
		marginLeft:'10px',
		width:'152px',
		padding:'6px 3px',
	}

	const handleOnGoNextClick = function() {
		goNext();
	}

	const handleOnGoPreviousClick = function() {
		goPrevious();
	}
	const disablePrevious = currentStep === 1;
	const disableNext     = maxSteps === currentStep;
	const btnNextClass = disableNext === true ? "btn btn-default":"btn btn-primary";
	const btnPreviousClass = disablePrevious === true ? "btn btn-default":"btn btn-primary";
	const iconStyle = saveComponentState === true ? "fa fa-spinner fa-spin":"fa fa-chevron-circle-right"
	const btnLabel  = saveComponentState === true ? "Saving":"Next"
	return (
		<div className="form-inline" style={{ paddingLeft:'62.5%' }}>
			<div className="form-group">
				<button className={btnPreviousClass} style={btnStyle} onClick={handleOnGoPreviousClick} disabled={ disablePrevious }><i className="fa fa-chevron-circle-left" aria-hidden="true"  />&nbsp;&nbsp;&nbsp;Previous</button>
			</div>
			<div className="form-group">
				<button className={btnNextClass} style={btnStyle}  onClick={handleOnGoNextClick} disabled={disableNext}>{btnLabel}&nbsp;&nbsp;&nbsp;<i className={iconStyle} aria-hidden="true" /></button>
			</div>
		</div>)
};
Navigation.propTypes = {
	goNext: PropTypes.func.isRequired,
	goPrevious: PropTypes.func.isRequired,
	currentStep: PropTypes.number.isRequired,
	maxSteps: PropTypes.number.isRequired,
	saveComponentState: PropTypes.bool,
};
export default Navigation


// WEBPACK FOOTER //
// ./src/components/common/wizard/components/navigation.js